import { IconWrapper } from '../runtime';
export default IconWrapper('folder-wechat-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 20.25C1.00736 20.25 0 19.2426 0 18L0 3C0 1.75736 1.00736 0.75 2.25 0.75L6.75 0.75C7.23683 0.75 7.71053 0.9079 8.1 1.2L9.9 2.55C10.2895 2.8421 10.7632 3 11.25 3L21.75 3C22.9926 3 24 4.00736 24 5.25L24 18C24 19.2426 22.9926 20.25 21.75 20.25L2.25 20.25Z",
      "fill": "#317FF2"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.25 22.5C1.00736 22.5 0 21.4926 0 20.25L0 7.5C0 6.25736 1.00736 5.25 2.25 5.25L21.75 5.25C22.9926 5.25 24 6.25736 24 7.5L24 20.25C24 21.4926 22.9926 22.5 21.75 22.5L2.25 22.5Z",
      "fill": 'url(#' + props.id + '4354715d' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.9688 13.125C16.9688 15.4549 14.7442 17.3437 12 17.3437C11.6368 17.3437 11.2827 17.3106 10.9416 17.2478L9.10316 18.2211C8.97479 18.289 8.82123 18.1915 8.82814 18.0465L8.90532 16.4257C7.7632 15.6528 7.03125 14.4615 7.03125 13.125C7.03125 10.795 9.25584 8.90625 12 8.90625C14.7442 8.90625 16.9688 10.795 16.9688 13.125ZM10.9496 12C10.9496 12.4142 10.5802 12.75 10.1246 12.75C9.66893 12.75 9.29956 12.4142 9.29956 12C9.29956 11.5858 9.66893 11.25 10.1246 11.25C10.5802 11.25 10.9496 11.5858 10.9496 12ZM14.6996 12C14.6996 12.4142 14.3302 12.75 13.8746 12.75C13.4189 12.75 13.0496 12.4142 13.0496 12C13.0496 11.5858 13.4189 11.25 13.8746 11.25C14.3302 11.25 14.6996 11.5858 14.6996 12Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '4354715d',
      "x1": "2.25",
      "y1": "6.43828",
      "x2": "19.1823",
      "y2": "24.658",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});